import React, { useId } from "react";

const overlayStyle = {
  backgroundColor: "rgba(214,210,200,0.72)",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
};

export const PreparingOverlaySpinner = ({ gradId = "default" }) => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" aria-hidden="true">
    <style>{`
      @keyframes qp-spin { to { transform: rotate(360deg); } }
      @keyframes qp-pulse { 0%,100%{opacity:.18} 50%{opacity:.55} }
      .qp-ring-outer { animation: qp-spin 1s linear infinite; transform-origin: 26px 26px; }
      .qp-ring-inner { animation: qp-spin 0.65s linear infinite reverse; transform-origin: 26px 26px; }
      .qp-dot { animation: qp-pulse 1.4s ease-in-out infinite; }
    `}</style>
    <circle cx="26" cy="26" r="22" stroke="#d6d2c8" strokeWidth="3" />
    <g className="qp-ring-outer">
      <circle
        cx="26"
        cy="26"
        r="22"
        stroke={`url(#qp-grad1-${gradId})`}
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="30 110"
      />
    </g>
    <g className="qp-ring-inner">
      <circle
        cx="26"
        cy="26"
        r="14"
        stroke={`url(#qp-grad2-${gradId})`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray="18 70"
      />
    </g>
    <circle className="qp-dot" cx="26" cy="26" r="4" fill="#9d2022" />
    <defs>
      <linearGradient id={`qp-grad1-${gradId}`} x1="4" y1="4" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#9d2022" />
        <stop offset="1" stopColor="#c0392b" stopOpacity="0.3" />
      </linearGradient>
      <linearGradient id={`qp-grad2-${gradId}`} x1="12" y1="12" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2c2420" />
        <stop offset="1" stopColor="#2c2420" stopOpacity="0.15" />
      </linearGradient>
    </defs>
  </svg>
);

/** Blurred full-screen loader used for Quick Prints preview/download and corporate flows. */
const PreparingOverlay = ({
  title,
  subtitle = "This may take a moment…",
  className = "fixed inset-0 z-[200] flex flex-col items-center justify-center",
}) => {
  const gradId = useId().replace(/:/g, "");

  return (
    <div
      className={className}
      style={overlayStyle}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={title}
    >
      <div className="flex flex-col items-center gap-4">
        <PreparingOverlaySpinner gradId={gradId} />
        <div className="flex flex-col items-center gap-1">
          <span className="text-[13px] font-semibold tracking-wide text-[#2c2420]">{title}</span>
          {subtitle ? (
            <span className="text-[11px] text-[#7a6e6e]">{subtitle}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PreparingOverlay;
